import { render, staticRenderFns } from "./BonusIndex.vue?vue&type=template&id=a9e0db4c&scoped=true"
import script from "./BonusIndex.vue?vue&type=script&lang=js"
export * from "./BonusIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e0db4c",
  null
  
)

export default component.exports